// hide the top navbar on the login page, keep it everywhere else
(function () {
	var navbar = document.querySelector("nav.navbar");
	if (!navbar) {
		return;
	}
	navbar.style.display = window.location.pathname.includes("login") ? "none" : "";
})();

// drop any "last visited page" redirect so login falls back to the user's
// own default workspace (or the home workspace), instead of wherever they were before logging out
(function () {
	var last_segment = window.location.pathname.replace(/\/+$/, "").split("/").pop();
	if (last_segment !== "login") {
		return;
	}

	var params = new URLSearchParams(window.location.search);
	if (!params.has("redirect-to")) {
		return;
	}
	params.delete("redirect-to");

	var query = params.toString();
	var new_url = window.location.pathname + (query ? "?" + query : "") + window.location.hash;
	window.history.replaceState(null, "", new_url);
})();

// Core's own post-login home_page can't resolve a private default workspace, so ask the server for the correct URL ourselves once login.js is ready.
$(document).on("login_rendered", function () {
	if (!window.login || !login.login_handlers || !login.login_handlers[200]) {
		return;
	}

	var original_200 = login.login_handlers[200];
	login.login_handlers[200] = function (data) {
		if (!data || data.message !== "Logged In") {
			return original_200(data);
		}

		login.set_status(__("Success"), "green");
		frappe.call({
			type: "GET",
			method: "seeds_india.seeds_india.api.login.get_post_login_redirect",
			callback: function (r) {
				window.location.href = (r && r.message) || data.home_page;
			},
			error: function () {
				window.location.href = data.home_page;
			},
		});
	};
});
